'use strict';
import angular from 'angular';
import './base/abtest.services';
import './base/abtest.ctrls';
import './base/abtest.directives';

angular.module('core.abtest', [
    'core.abtest.services'
]);